import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import './style.css';

import AboutUsSection from '../../Components/AboutUsSection';
// import GlimpsSection from '../../Components/GlimpsSection';
import AffiliateCompanies from '../../Components/AffiliateCompanies';
import TeamMembers from '../../Components/TeamMembers';
// import GetInTouchSection from '../../Components/GetInTouchSection';
// import StayConnected from '../../Components/StayConnectedSection';

export default function AboutUs() {
  const location = useLocation();

  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  return (
    <div className='about-us-page'>
      <Helmet>
        <title>About Starlife Group</title>
        <meta
          name='description'
          content='Learn about Starlife Group’s commitment to excellence in real estate development, exclusive investments, and luxury properties.'
        />
        <meta
          name='keywords'
          content='Exclusive real estate investment, Luxury office spaces, Real estate development company, Starlife Group properties'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>

      <AboutUsSection />
      <AffiliateCompanies />
      {/* <GlimpsSection /> */}
      <TeamMembers/>
      {/* <GetInTouchSection /> */}
      {/* <StayConnected /> */}
    </div>
  );
}
